"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MargedInputField = void 0;
const react_1 = __importDefault(require("react"));
const crumble_1 = require("@oclock/crumble");
const MargedInputField = (props) => (react_1.default.createElement("div", { style: { margin: '12px 12px' } },
    react_1.default.createElement(crumble_1.InputField, Object.assign({}, props))));
exports.MargedInputField = MargedInputField;
